import { useSetAtom } from 'jotai';

import { closeDrawerAtom } from '../../atoms/editDrawerAtoms';
import { updateSearchValueAtom } from '../../atoms/inventoryAtoms';

/**
 * Custom hook that provides action handler for search input changes
 * Updates search value and closes the drawer when search is performed
 */
export const useSearchAction = () => {
	const updateSearchValue = useSetAtom(updateSearchValueAtom);
	const closeDrawer = useSetAtom(closeDrawerAtom);

	const handleSearchChange = (value: string) => {
		updateSearchValue(value);
		closeDrawer();
	};

	return {
		handleSearchChange,
	};
};
